export default function IconMark() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                stroke="#707070"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.58984 8.99996C9.82495 8.33163 10.289 7.76807 10.8998 7.40909C11.5106 7.05012 12.2287 6.9189 12.927 7.03867C13.6253 7.15844 14.2587 7.52148 14.7149 8.06349C15.1712 8.60549 15.4209 9.29148 15.4198 9.99996C15.4198 12 12.4198 13 12.4198 13V14.5"
                stroke="#707070"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12.5 17H12.51" stroke="#707070" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
